import React, { useEffect, useState } from "react";
import "./static.css";
import { Helmet } from "react-helmet";

const DummyPage: React.FC = () => {
  useEffect(() => {
    document.title = "About";
  }, []);
  return (
    <div className="dummy-container-static">
      <Helmet key="About">
        <title>About</title>
        <meta
          name="description"
          content="About Trialhouse and the Ivy Bloat Tracker."
        />
      </Helmet>
      <h1 className="dummy-heading1-static">About</h1>
      <h2 className="dummy-heading2-static">
        Trialhouse + Ivy League Bloat Tracker
      </h2>
      <p className="dummy-paragraph-static">
        Trialhouse, an AI-powered legal watchdog, has teamed up with student
        journalists from Brown, Columbia, Cornell, and Penn to expose the
        bloated Ivy League bureaucracies bankrolled by student tuition — and
        until recently, American taxpayers. The team has published directories
        of administrative employees at all four schools and is emailing each
        employee to ask a simple question: What do you do all day?
      </p>
      <p className="dummy-paragraph-static">
        Trialhouse is also inviting the public to use its Grok-powered cease and
        desist letter generator to tell their favorite (or least favorite)
        school to cease and desist DEI — a practice the Supreme Court has ruled
        violates the Civil Rights Act and which the Trump administration warned
        could justify pulling federal funds.
      </p>
      <h2 className="dummy-heading2-static">The Motivation</h2>
      <p className="dummy-paragraph-static">
        An Ivy League degree was once a ticket to the American Dream. But with
        tuition and fees now topping $90,000 a year — and a Congressional
        investigation underway into price-fixing — that dream sits behind a
        paywall. At current growth rates, Ivy League tuition will cross $100,000
        by 2027.
      </p>
      <p className="dummy-paragraph-static">
        What’s driving the cost? Administrative bloat. Universities have quietly
        hired legions of desk-bound bureaucrats whose day-to-day contributions
        are often vague, redundant, or political. Among them: dozens of DEI
        officers, whose programs have cost schools billions in lost federal
        funding — costs that students are left to absorb.
      </p>
      <h2 className="dummy-heading2-static">The Backstory</h2>
      <p className="dummy-paragraph-static">
        The project began as Bloat@Brown, and quickly struck a national nerve.
        It earned coverage from Elon Musk, Bill Ackman, Charlie Kirk, Fox News,
        Newsweek, and the New York Post — and sparked an official disciplinary
        investigation from Brown for allegedly causing “emotional harm.”
      </p>
      <h2 className="dummy-heading2-static">See More</h2>
      <p className="dummy-paragraph-static">
        <a
          className="dummy-link-static"
          href="/contact"
          rel="noopener noreferrer"
        >
          Contact the team
        </a>
      </p>
      <p className="dummy-paragraph-static">
        <a
          className="dummy-link-static"
          href="https://x.com/alexkshieh"
          target="_blank"
          rel="noopener noreferrer"
        >
          Check us out on X
        </a>
      </p>
    </div>
  );
};

export default DummyPage;
